<template>
    <table class="table table-striped">
        <thead>
            <tr>
            <th>Date</th>
            <th>Team</th>
            <th>Name</th>
            <th>Firstname</th>
            <th>workhours</th>
            <th></th>
            </tr>   
        </thead>
        <tbody>
             <tr v-for="employeeDay in employeeDaysOver10h">
                <td>{{ toISODate(employeeDay.day) }}</td>
                <td>{{ employeeDay.employee.team.name }}</td>
                <td>{{ employeeDay.employee.lastname }}</td>
                <td>{{ employeeDay.employee.forename }}</td>
                <td>{{ employeeDay.workhours }}</td>
                <td></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import axios from "axios";
import { luxonParseDate } from "../transformDate";

export default {
    setup() {
    },
    name: "EmployeeDaysOver10h",
    created() {
    },
    props: {
        date_filter_option_id: String,
        date_filter_value: String,
        teamId: Number,
        employerId: Number,
        locationId: Number,
        divisionId: Number,
    },
    data() {
        return {
            employeeDaysOver10h: null,
        };
    },
    computed: {
    },
    mounted() {
    },
    watch: {
        date_filter_value(newValue, oldValue) {
            if(this.date_filter_value != 'undefined'){
                this.fetchEmployeeDaysOver10h();
            }
        }
    },
    methods: {
        fetchEmployeeDaysOver10h() {
            var params = {
                        teamId: this.teamId,
                        employerId: this.employerId,
                        locationId: this.locationId,
                        divisionId: this.divisionId,
                        dateFilterOption: this.date_filter_option_id,
                        dateFilterValue: this.date_filter_value,
                    };
            axios
                .get("/api/employeedays/over10hours", {
                    params: params})
                .then((resp) => {
                    this.employeeDaysOver10h = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        toISODate(date) {
            let newDate = luxonParseDate(date).toISODate();
            return newDate;
        },
    }
};
</script>
